import React from "react";
import ContactItem from "./contactItem";
import Phone from "../assets/icons/phone.svg";
import Email from "../assets/icons/email.svg";
import Web from "../assets/icons/web.svg";

export default function Contact({ data }) {
  return (
    <section id="contact">
      {data.phone && (
        <ContactItem
          icon={Phone}
          contactName="Cell Phone"
          contactValue={data.phone}
        />
      )}
      {data.companyPhone && (
        <ContactItem
          icon={Phone}
          contactName="Work Phone"
          contactValue={data.companyPhone}
        />
      )}
      {data.email && (
        <ContactItem
          icon={Email}
          contactName="Email"
          contactValue={data.email}
        />
      )}
      {data.linkedinUrl && (
        <ContactItem
          icon={Web}
          contactName="Web"
          contactValue={data.link}
        />
      )}
    </section>
  );
}
